import React from 'react';
import { useLocation } from 'react-router';
import _get from 'lodash/get';
import { DataList, EMPTY_STRING } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { makeActionList } from '../../actions/ShowBulkAction';
import { makeActionHandler } from '../../actions/handlers';
import { columnConfigs } from './showBulkConfig';
import useService from '../../utils/useService';

const ShowBulkCoupons: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);

	const location = useLocation();
	const cid = _get(location, ['state', 'rowData', '_id'], EMPTY_STRING);
	const { showBulkCouponData } = useService();

	const actions = getActionList();
	return (
		<DataList
			fetchData={showBulkCouponData(cid)}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.BULK_PARTNER_COUPONS}
		/>
	);
};

export default ShowBulkCoupons;
